<!-- doctor-onboarding-wizard.component.html -->
<div class="container">
  <div class="row justify-content-center">
    <div class="col-md-10 col-lg-8">
      <div class="card shadow rounded-4 border-0">
        <div class="card-body p-4">
          <!--          <div class="mb-4 text-center">-->
          <!--            <h2 class="fw-bold">Doctor Onboarding</h2>-->
          <!--            <p class="text-muted">Step {{ step }} of 3</p>-->
          <!--          </div>-->

          <user-onboarding (submitStep)="submitUserOnboarding($event)"></user-onboarding>

          <!--          @if (step === 1) {-->
          <!--          }-->
          <!--          @if(step === 2) {-->
          <!--            <doctor-onboarding (submitDoctor)="submitDoctor($event)"></doctor-onboarding>-->
          <!--          }-->
          <!--          @if (step === 3) {-->
          <!--            <doctor-verification (submit)="verifyDocuments($event)"></doctor-verification>-->
          <!--          }-->

          <!--          <div class="d-flex justify-content-between mt-4">-->
          <!--            @if (step > 1) {-->
          <!--              <button type="button" class="btn btn-outline-secondary" (click)="prevStep()">Back</button>-->
          <!--            }-->
          <!--            <div class="ms-auto">-->
          <!--              @if (step < 3) {-->
          <!--                <button type="button" class="btn btn-primary px-4" (click)="nextStep()">Next</button>-->
          <!--              }-->
          <!--              @if (step === 3) {-->
          <!--                <button type="button" class="btn btn-success px-4" (click)="onSubmit()">Submit</button>-->
          <!--              }-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</div>
